<template lang="pug">
    div
        v-list(dense)

            v-list-item(ripple link to="/")
                v-list-item-action
                    v-icon mdi-home
                v-list-item-content
                    v-list-item-title Home

            v-list-item(ripple link to="/organizations")
                v-list-item-action
                    v-icon mdi-office-building
                v-list-item-content
                    v-list-item-title Organizations

            v-list-item(ripple link to="/reports")
                v-list-item-action
                    v-icon mdi-folder-open
                v-list-item-content
                    v-list-item-title Reports

        v-divider

        v-list(dense)
            v-list-item(ripple :to="`/users/${currentUser.user_key}/edit`")
                v-list-item-action
                    v-icon mdi-account
                v-list-item-content
                    v-list-item-title Profile

            v-list-item(ripple link :href="'/api_docs'")
                v-list-item-action
                    v-icon mdi-notebook
                v-list-item-content
                    v-list-item-title Api Docs

            v-list-item(ripple link href="https://intercom.help/volie/en" target="_blank")
                v-list-item-action
                    v-icon mdi-help-circle
                v-list-item-content
                    v-list-item-title Help

            //- v-list-item(ripple link to="/privacy_policy")
            //-     v-list-item-action
            //-         v-icon mdi-security
            //-     v-list-item-content
            //-         v-list-item-title Privacy Policy

            //- v-list-item(ripple link to="/terms_and_conditions")
            //-     v-list-item-action
            //-         v-icon mdi-clipboard-text
            //-     v-list-item-content
            //-         v-list-item-title Terms and Conditions

            v-list-item(ripple link :href="railsVolieBaseUrl + '/log_out'")
                v-list-item-action
                    v-icon mdi-logout
                v-list-item-content
                    v-list-item-title Logout

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
        },
        computed: {
            currentUser() {
                return VolieState.currentUser();
            },
            railsVolieBaseUrl() {
                return VolieState.baseRailsUrl();
            },
        },
        components: {
        },
        props: {
        },
    });
</script>

<style lang="scss" scoped>
</style>
